module.exports = __webpack_public_path__ + "img/グループ 259.b1d1782e.png";